class RefillLoadMore extends HTMLElement {
  constructor() {
      super();

      this.button = this.querySelector('.js-collection-grid-load-more');
      this.quantity = this.querySelector('.js-collection-grid-load-more-qty');

      this.button.addEventListener('click', this.onButtonClick.bind(this))
      window.addEventListener('scroll', this.onWindowScroll.bind(this))
  }

  onWindowScroll() {
      if (this.isInViewport(this.button) && !this.classList.contains('collection-grid__load-more-wrapper--hidden')) {
        this.onButtonClick()
      }
  }

  isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
  }

  onButtonClick() {
    if(this.button.disabled) return;

    this.button.disabled = true;

    setTimeout(() => {
      this.button.disabled = false;

      const hiddenProduct = document.querySelectorAll('.collection-grid__product--hidden');

      hiddenProduct.forEach((product, index) => {
        if(index < 9) {
          product.classList.remove('collection-grid__product--hidden');
        }
      });

      this.quantity.innerText = +this.quantity.innerText + 9;

      if(+this.quantity.innerText >= +this.quantity.dataset.max) {
        this.quantity.innerText = +this.quantity.dataset.max;
        this.classList.add('collection-grid__load-more-wrapper--hidden');
      }
    }, 1000);
  }
}

customElements.define('refill-load-more', RefillLoadMore);